import { Component, Input } from '@angular/core';

@Component({
  selector: 'muni-gameday-progress-bar',
  templateUrl: './progress-bar.template.html',
  styleUrls: ['./progress-bar.styles.scss'],
  standalone: false,
})
export class ProgressBarComponent {
  @Input()
  public value = 0;
  @Input()
  public height = 20;
}
